import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

  transform(lista: Array<any>, args: any): any {

    if (args !== undefined) {
      if (args === 'Menor Preço') {
        lista = _.orderBy(lista, ['pontos'], ['asc']);
      } else if (args === 'Maior Preço') {
        lista = _.orderBy(lista, ['pontos'], ['desc']);
      } else if (args === 'A-Z') {
        lista = _.orderBy(lista, ['nome'], ['asc']);
      } else if (args === 'Z-A') {
        lista = _.orderBy(lista, ['nome'], ['desc']);
      } else {
        lista = _.sortBy(lista, [args]);
      }
    } else {
      lista = lista.sort();
    }
    return lista;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/pipes/order-by.pipe.ts